import { createContext, useContext, useEffect, useState } from "react";

const I18nContext = createContext();

const translations = {
  ru: {
    nav: {
      benefits: "Преимущества",
      process: "Процесс",
      countries: "Страны",
      vacancies: "Вакансии",
      team: "Команда",
      about: "О нас",
      contacts: "Контакты",
      reviews: "Отзывы",
      payment: "Оплата",
      license: "Лицензия",
      admin: "Админ",
    },
    common: {
      learn_more: "Подробнее",
      send: "Отправить",
      cancel: "Отмена",
      save: "Сохранить",
      delete: "Удалить",
      edit: "Редактировать",
      add: "Добавить",
      loading: "Загрузка...",
      back_to_top: "Наверх",
      back_home: "На главную",
    },
    reviews_form: {
      name: "Ваше имя",
      country: "Страна",
      role: "Должность",
      rating: "Оценка",
      text: "Ваш отзыв",
      phone: "Номер телефона",
      email: "Электронная почта",
      submit: "Отправить отзыв",
      placeholder_text: "Расскажите о вашем опыте сотрудничества с TEMPEO...",
      contact_warning: "Контактные данные обязательны: без них отзыв не будет рассматриваться. Мы свяжемся с вами для верификации.",
      contact_private: "Ваш телефон и email видны только администратору и не публикуются на сайте.",
    },
    pages: {
      privacy: "Политика конфиденциальности",
      terms: "Пользовательское соглашение",
      refund: "Политика возврата",
    },
    footer: {
      legal: "Юридическая информация",
      contact_us: "Связаться с нами",
    },
  },
  en: {
    nav: {
      benefits: "Benefits",
      process: "Process",
      countries: "Countries",
      vacancies: "Vacancies",
      team: "Team",
      about: "About",
      contacts: "Contacts",
      reviews: "Reviews",
      payment: "Payment",
      license: "License",
      admin: "Admin",
    },
    common: {
      learn_more: "Learn more",
      send: "Send",
      cancel: "Cancel",
      save: "Save",
      delete: "Delete",
      edit: "Edit",
      add: "Add",
      loading: "Loading...",
      back_to_top: "Top",
      back_home: "Back home",
    },
    reviews_form: {
      name: "Your name",
      country: "Country",
      role: "Role",
      rating: "Rating",
      text: "Your review",
      phone: "Phone number",
      email: "Email",
      submit: "Send review",
      placeholder_text: "Tell us about your experience with TEMPEO...",
      contact_warning: "Contact details are required: reviews without them will not be considered. We will reach out to verify.",
      contact_private: "Your phone and email are visible only to the administrator and never published.",
    },
    pages: {
      privacy: "Privacy Policy",
      terms: "Terms of Conditions",
      refund: "Refund Policy",
    },
    footer: {
      legal: "Legal",
      contact_us: "Contact us",
    },
  },
};

export const I18nProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("tempeo_lang") || "ru");
  useEffect(() => {
    localStorage.setItem("tempeo_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);
  const t = (key) => {
    const parts = key.split(".");
    let cur = translations[lang];
    for (const p of parts) cur = cur?.[p];
    return cur ?? key;
  };
  return (
    <I18nContext.Provider value={{ lang, setLang, t }}>
      {children}
    </I18nContext.Provider>
  );
};

export const useI18n = () => useContext(I18nContext);

// Helper to pick localized field from content blocks
export const pick = (obj, lang, fallback = "") => {
  if (!obj) return fallback;
  if (typeof obj === "string") return obj;
  return obj[lang] ?? obj.ru ?? obj.en ?? fallback;
};
